import { type VariantProps } from "class-variance-authority";
import * as React from "react";

import { inputVariants } from "./input-variants";

import { cn } from "@/lib/utils/cn";

interface InputProps
  extends Omit<React.ComponentProps<"input">, "size">,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type = "text", variant, size, caretPosition, ...props },
    ref
  ) => (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      data-variant={variant ?? "default"}
      className={cn(inputVariants({ variant, size, caretPosition, className }))}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input, type InputProps };
